import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * BackToTop — discreet, brand-tinted floating button that appears once the
 * user has scrolled past 600px. Sits ABOVE the AI assistant bubble (bottom-24)
 * so they never overlap on mobile.
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      data-testid="back-to-top-btn"
      aria-label="Natrag na vrh"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed right-5 bottom-24 z-[60] w-11 h-11 rounded-full bg-[#b41c1f] hover:bg-[#8a1518] text-white shadow-lg shadow-[#b41c1f]/40 hover:shadow-xl transition-all flex items-center justify-center"
    >
      <ArrowUp size={20} strokeWidth={2.5} />
    </button>
  );
}
